import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { QuoteConfigEffects } from './quote-config.effects';

@NgModule({
    declarations: [],
    imports: [CommonModule, EffectsModule.forFeature([QuoteConfigEffects])],
})
export class QuoteConfigModule {}

export * as QuoteConfigActions from './quote-config.actions';
